import { render } from "./CreateOrUpdateUserModal.vue?vue&type=template&id=4c518a38&scoped=true"
import script from "./CreateOrUpdateUserModal.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateUserModal.vue?vue&type=script&lang=js"

import "./CreateOrUpdateUserModal.vue?vue&type=style&index=0&id=4c518a38&lang=css"
import "./CreateOrUpdateUserModal.vue?vue&type=style&index=1&id=4c518a38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c518a38"]])

export default __exports__